import React from 'react'
import type { IPublicClientApplication } from '@azure/msal-browser'
import type { app as TeamsApp } from '@microsoft/teams-js'
import { RouterProvider } from 'react-router-dom'
import { MsalProvider } from '@azure/msal-react'
import { ErrorBoundary } from '@/components/ErrorBoundary'
import { AuthGate } from '@/components/AuthGate'
import { NotificationProvider } from '@/contexts/NotificationContext'
import { HostProvider } from '@/contexts/HostContext'
import type { HostKind, TeamsThemeName } from '@/lib/teamsHost'
import { router } from '@/router'

interface AppProps {
  msalInstance: IPublicClientApplication
  host: HostKind
  initialTheme: TeamsThemeName
  teamsContext: TeamsApp.Context | null
}

const App: React.FC<AppProps> = ({ msalInstance, host, initialTheme, teamsContext }) => {
  return (
    <ErrorBoundary>
      <HostProvider host={host} initialTheme={initialTheme} teamsContext={teamsContext}>
        <MsalProvider instance={msalInstance}>
          <AuthGate host={host}>
            <NotificationProvider>
              <RouterProvider router={router} />
            </NotificationProvider>
          </AuthGate>
        </MsalProvider>
      </HostProvider>
    </ErrorBoundary>
  )
}

export default App
